import React from 'react';
import { styled } from "../../../stitches.config";
import Link from "../../../components/Link";
import { bodyLarge } from "../../../redesign/commonStyles/Fonts";
import MyAccountIco from "../../../redesign/assets/icons/myaccount.svg";

import WhatsAppIcon from "../../../redesign/assets/icons/whatsapp-icon.svg";
import useMediaQuery from '../../../helpers/useMediaQuery';

import { IS_FEATURE_CTA_SUPPORT_BUTTON } from '../../../components/common/constants/constants.js';
import CtaSupportButton from './CtaSupportButton';
import { useStores } from "../../../helpers";

type CtaButtonProps = {
    brand?: Config.Brand;
};

export const CtaButton: React.FC<CtaButtonProps> = ({
    brand = window.BRAND,
    ...props
}) => {

    const isDesktop = useMediaQuery('bp4');
    const config = window.APP_SETTINGS.cta_button;

    const { UIStore } = useStores();
    const isMaterialPartnera = UIStore.isMaterialPartnera;
    const isAd = (config?.ad == 1 ? true : false)

    const defaultName = (
        <>
            Chcesz czytać naTemat.pl bez reklam i personalizować portal? Załóż konto "Twoje naTemat"
        </>
    );

    const defaultNameMobile = (
        <>
            Obserwuj naTemat na WhatsApp
        </>
    );


    return (
        <>
            {IS_FEATURE_CTA_SUPPORT_BUTTON && !isDesktop ?
                <CtaSupportButton />
                :
                <>
                    {
                        isMaterialPartnera && isAd ?
                            <StyledCtaButton className={bodyLarge()}>
                                <Link data-analytics-name="article-cta-account-btn" to={isDesktop ? "https://natemat.pl/423181,twoje-natemat-to-portal-bez-reklam-rewolucyjna-zmian-w-natemat-pl?BT=" : "https://whatsapp.com/channel/0029Va9FnKdBKfi5CnMLER2A"}>
                                    <StyledHomeIcon />
                                    {isDesktop ? defaultName : defaultNameMobile}
                                </Link>
                            </StyledCtaButton>
                            :
                            <StyledCtaButton className={bodyLarge()}>
                                {isAd && <AdLabel>Reklama.</AdLabel>}
                                {config?.target ?
                                    <a data-analytics-name="article-cta-account-btn" href={config?.link || (isDesktop ? "https://natemat.pl/423181,twoje-natemat-to-portal-bez-reklam-rewolucyjna-zmian-w-natemat-pl?BT=" : "https://whatsapp.com/channel/0029Va9FnKdBKfi5CnMLER2A")} target={config?.target}>
                                        {config?.icon ?
                                            <StyledIcon src={config.icon} />
                                            :
                                            <StyledHomeIcon />
                                        }
                                        {config?.name || (isDesktop ? defaultName : defaultNameMobile)}
                                    </a>
                                    :
                                    <Link data-analytics-name="article-cta-account-btn" to={config?.link || (isDesktop ? "https://natemat.pl/423181,twoje-natemat-to-portal-bez-reklam-rewolucyjna-zmian-w-natemat-pl?BT=" : "https://whatsapp.com/channel/0029Va9FnKdBKfi5CnMLER2A")}>
                                        {config?.icon ?
                                            <StyledIcon src={config.icon} />
                                            :
                                            <StyledHomeIcon />
                                        }
                                        {config?.name || (isDesktop ? defaultName : defaultNameMobile)}
                                    </Link>
                                }
                            </StyledCtaButton>
                    }
                </>
            }
        </>
    )
};


const StyledCtaButton = styled('div', {
    "a": {
        width: "100%",
        margin: "0 auto 18px auto",
        color: "$grayscale0Fixed !important",
        backgroundColor: "$primary",
        border: "2px solid $primary",
        cursor: "pointer",
        padding: "16px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        "&:hover": {
            backgroundColor: "$primary120",
            border: "2px solid $primary120",
        },
    }
})

const StyledHomeIcon = styled('div', {
    display: "flex",
    marginRight: "16px",
    width: "16px",
    height: "17px",
    backgroundImage: `url("${WhatsAppIcon}")`,
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    flexShrink: 0,
    "@bp4": {
        backgroundImage: `url("${MyAccountIco}")`,
    }
});

const StyledIcon = styled('img', {
    marginRight: "16px",
    width: "20px",
    height: "20px",
    flexShrink: 0,
});


const AdLabel = styled('div', {
    fontSize: "11px",
    color: "#a5a5a5",
    background: "#e3e3e3",
    padding: "2px 6px",
    lineHeight: "20px",
    maxWidth: "60px",
    "&:hover": {
        textDecoration: "none !important",
        color: "#a5a5a5",
    }
});

export default CtaButton